import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Header2 from './Header2';
import Footer from './Footer';
import * as api from '../api/api';

const ProjectDetails = () => {
    const { id } = useParams();
    const [project, setProject] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const getProject = async () => {
            try {
                const { data } = await api.fetchProjectById(id);
                setProject(data);
                setLoading(false);
            } catch (error) {
                console.log(error);
                setLoading(false);
            }
        };

        getProject();
        window.scrollTo(0, 0);
    }, [id]);

    if (loading) return <div className="text-center pt-100"><h2>Loading Project...</h2></div>;
    if (!project) return <div className="text-center pt-100"><h2>Project Not Found</h2></div>;

    return (
        <div className="home-one">
            <Header2 />

            <section className="page-banner-area pt-200 rpt-140 pb-100 rpb-60 rel z-1 text-center">
                <div className="container">
                    <div className="banner-inner text-white">
                        <h1 className="page-title wow fadeInUp delay-0-2s">{project.title}</h1>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb justify-content-center wow fadeInUp delay-0-4s">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active">Project Details</li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <div className="bg-lines">
                    <span></span><span></span>
                    <span></span><span></span>
                    <span></span><span></span>
                    <span></span><span></span>
                    <span></span><span></span>
                </div>
            </section>

            <section className="project-details-area pt-130 rpt-100 pb-100 rpb-70 rel z-1">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="project-details-image mb-50 wow fadeInUp delay-0-2s">
                                <img src={api.getImageUrl(project.img)} alt={project.title} style={{ width: "100%", borderRadius: "15px", height: "500px", objectFit: "cover" }} />
                            </div>
                        </div>
                    </div>
                    <div className="row gap-120">
                        <div className="col-lg-8">
                            <div className="project-details-content wow fadeInUp delay-0-2s">
                                <h3>Project Overview</h3>
                                <p className="big-letter">{project.longDesc}</p>

                                {project.projectFlow && project.projectFlow.length > 0 && (
                                    <>
                                        <h3 className="mt-50">Project Flow</h3>
                                        <ul className="list-style-one heading-six">
                                            {project.projectFlow.map((step, index) => (
                                                <li key={index}>{step}</li>
                                            ))}
                                        </ul>
                                    </>
                                )}

                                <div className="row mt-50">
                                    {project.moreImages && project.moreImages.slice(1).map((img, index) => (
                                        <div key={index} className="col-lg-4 col-md-6 col-sm-12">
                                            <div className="image mb-30 wow fadeInUp delay-0-2s">
                                                <img src={api.getImageUrl(img)} alt={`Project Screenshot ${index + 2}`} style={{ borderRadius: "10px", width: "100%", height: "250px", objectFit: "cover" }} />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                {project.videoLink && (
                                    <div className="mt-50">
                                        <h3>Project Video</h3>
                                        <div className="video-container" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                                            <iframe
                                                src={project.videoLink.replace('watch?v=', 'embed/')}
                                                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                                                frameBorder="0"
                                                allowFullScreen
                                                title="Project Video"
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="project-details-info wow fadeInUp delay-0-4s">
                                <div className="pd-info-item">
                                    <span>Category</span>
                                    <h5>{project.category || "Web Application"}</h5>
                                </div>
                                <div className="pd-info-item">
                                    <span>Clients</span>
                                    <h5>{project.client || "Confidential"}</h5>
                                </div>
                                <div className="pd-info-item">
                                    <span>Technologies</span>
                                    <h5>
                                        {project.technologies && project.technologies.join(", ")}
                                    </h5>
                                </div>
                                {project.liveLink && (
                                    <div className="pd-info-item">
                                        <span>Live Preview</span>
                                        <h5><a href={project.liveLink} target="_blank" rel="noopener noreferrer">View Live</a></h5>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bg-lines">
                    <span></span><span></span>
                    <span></span><span></span>
                    <span></span><span></span>
                    <span></span><span></span>
                    <span></span><span></span>
                </div>
            </section>

            <Footer />
        </div>
    );
}

export default ProjectDetails;